<div style="min-height: 70vh" fxLayout fxLayoutAlign="center center">
  <p fxFlex class="text--center">
    <strong style="font-size: 20px">Accès refusé, vous allez être déconnecté.</strong>
  </p>
</div>